module.exports = __webpack_public_path__ + "media/images/icon__whatsapp@2x-e013bd895bafbd903acec8c4fb170c6e.png";